import {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  useContext,
} from "react";
import {useManager} from "../functions/getManager";
import {
  CampaignTypeData,
  useCampaignTypes,
} from "../functions/getCampaignType";
import {ManagerProps} from "../../../global/schemas/data/managers/manager";
import {useGetCampaign} from "../functions/getCampaigns";
import {CampaignProps} from "../../../global/schemas/data/campaigns/campaign";

interface DataContextInterface {
  manager: ManagerProps | null | undefined;
  campaignTypes: CampaignTypeData[] | undefined | null;
  campaigns: CampaignProps[] | undefined | null;
}

const DataContext = createContext<DataContextInterface | undefined>(undefined);
export const AdminDataProvider: FunctionComponent<
  PropsWithChildren<{ managerId: string }>
> = ({children, managerId}) => {
  const managerData = useManager(managerId);
  const {data: campaignTypes} = useCampaignTypes(managerData?.groups);
  const campaignData = useGetCampaign(managerId);

  return (
    <DataContext.Provider
      value={{
        campaignTypes,
        manager: managerData,
        campaigns: campaignData,
      }}>
      {children}
    </DataContext.Provider>
  );
};

export function useAdminData() {
  const context = useContext(DataContext);

  if (!context) {
    throw new Error("context used outside provider");
  }

  return context;
}
